module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[30]151.7362b8b.woff2";